<button class="btn btn-info" (click)="fullScreen()">
  {{btnText}}
</button>